import { isObserver } from "assistant/userRole";

export function userCreationAuthHeaders(token = localStorage.getItem("tk446655440000")) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function normalizeIdCsv(value) {
  const values = Array.isArray(value) ? value : String(value ?? "").split(",");
  return [...new Set(values.map((id) => String(id).trim()).filter(Boolean))].join(",");
}

export function normalizeCreatableRoles(payload) {
  const roles = Array.isArray(payload) ? payload : Array.isArray(payload?.roles) ? payload.roles : [];
  const allowed = new Map([
    ["admin", "Admin"],
    ["observer", "Observer"],
  ]);
  return [...new Set(roles.map((role) => allowed.get(String(role).trim().toLowerCase())).filter(Boolean))];
}

export function validateGeographicSelection(role, provinces, departments, provinceOptions, departmentOptions) {
  const provinceIds = normalizeIdCsv(provinces).split(",").filter(Boolean);
  const departmentIds = normalizeIdCsv(departments).split(",").filter(Boolean);
  const allowedProvinces = new Set((provinceOptions || []).map((option) => String(option.id)));
  const allowedDepartments = new Set((departmentOptions || []).map((option) => String(option.id)));

  if (isObserver(role) && (!provinceIds.length || !departmentIds.length)) {
    return { valid: false, reason: "Observer accounts require at least one province and one department." };
  }
  if (provinceIds.some((id) => !allowedProvinces.has(id))) {
    return { valid: false, reason: "One or more selected provinces are not available to your account." };
  }
  if (departmentIds.some((id) => !allowedDepartments.has(id))) {
    return { valid: false, reason: "One or more selected departments are outside the selected provinces." };
  }
  return { valid: true, provinces: provinceIds.join(","), departments: departmentIds.join(",") };
}

export function appendUserCreationFields(formData, values, provinceOptions, departmentOptions) {
  const geo = validateGeographicSelection(
    values.role,
    values.Provinces,
    values.Departments,
    provinceOptions,
    departmentOptions
  );
  if (!geo.valid) throw new Error(geo.reason);

  formData.append("Username", values.email);
  formData.append("Email", values.email);
  formData.append("Password", values.password);
  formData.append("FirstName", values.firstName);
  formData.append("LastName", values.lastName);
  formData.append("Title", values.title.trim());
  formData.append("Gender", values.gender);
  formData.append("Phone", values.phone);
  formData.append("WhastappNo", values.whastappNo);
  formData.append("Role", isObserver(values.role) ? "Observer" : values.role);
  formData.append("Provinces", geo.provinces);
  formData.append("Departments", geo.departments);
  return formData;
}

export function backendValidationMessage(error, fallback) {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (typeof data?.message === "string" && data.message.trim()) return data.message;
  const errors = Array.isArray(data?.errors)
    ? data.errors
    : data?.errors && typeof data.errors === "object"
      ? Object.values(data.errors).flat()
      : [];
  return errors.find((message) => typeof message === "string" && message.trim()) || error?.message || fallback;
}
